import { render, staticRenderFns } from "./Bespoke.vue?vue&type=template&id=25d00184&"
import script from "./Bespoke.vue?vue&type=script&lang=js&"
export * from "./Bespoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports